var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 32 32","fill":"none"}},[_c('path',{attrs:{"d":"M9.06712 23.8333L7.63379 22.4L14.0338 16L7.63379 9.6L9.06712 8.16667L16.9005 16L9.06712 23.8333ZM22.0005 24V8H24.0005V24H22.0005Z","fill":_vm.color,"fill-opacity":"0.38"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }